import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateConnectivity, fetchConnectivity } from "../../../Redux/Slices/connectivitySlice";
import { useProperty } from "../../../PropertyContext";
import swal from "sweetalert";

export const EditConnectivity = ({ connectivityData }) => {

    const dispatch = useDispatch();
    const { selectedProperty } = useProperty();

    const [formData, setFormData] = useState({
        ID: "",
        PlaceName: "",
        Distance: "",
        SortOrder: ""
    });

    const [loading, setLoading] = useState(false);

    // ✅ Prefill form
    useEffect(() => {
        if (connectivityData) {
            setFormData({
                ID: connectivityData.ID,
                PlaceName: connectivityData.PlaceName,
                Distance: connectivityData.Distance,
                SortOrder: connectivityData.SortOrder
            });
        }
    }, [connectivityData]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            const resultAction = await dispatch(updateConnectivity(formData));

            if (updateConnectivity.fulfilled.match(resultAction)) {

                // ✅ Fresh fetch
                await dispatch(fetchConnectivity(selectedProperty.PropertyID));

                swal("Success!", "Connectivity updated successfully!", "success");

                // Close modal
                document.querySelector('#Edit-Connectivity .btn-close').click();

            } else {
                swal("Error!", "Update failed!", "error");
            }

        } catch (error) {
            swal("Error!", "Something went wrong!", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="row">

                    <div className="col-md-12 mb-3">
                        <input
                            type="text"
                            name="PlaceName"
                            value={formData.PlaceName}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Place Name"
                        />
                    </div>

                    <div className="col-md-12">
                        <input
                            type="text"
                            name="Distance"
                            value={formData.Distance}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Distance"
                        />
                    </div>

                    <div className="col-md-12">
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </div>

                </div>
            </form>
        </>
    )
}
